import {
    TODAYS_RESERVATION_OVERVIEW_REQUEST,
    TODAYS_RESERVATION_OVERVIEW_SUCCESS,
    TODAYS_RESERVATION_OVERVIEW_FAILURE,

    TODAYS_RESERVATION_VOLUME_BY_SESSION_REQUEST,
    TODAYS_RESERVATION_VOLUME_BY_SESSION_SUCCESS,
    TODAYS_RESERVATION_VOLUME_BY_SESSION_FAILURE,

    TODAYS_ASSIGNED_RESERVATION_REQUEST,
    TODAYS_ASSIGNED_RESERVATION_SUCCESS,
    TODAYS_ASSIGNED_RESERVATION_FAILURE,

    TODAYS_UPCOMING_RESERVATION_REQUEST,
    TODAYS_UPCOMING_RESERVATION_SUCCESS,
    TODAYS_UPCOMING_RESERVATION_FAILURE,

    UPCOMING_RESERVATION_OVERVIEW_REQUEST,
    UPCOMING_RESERVATION_OVERVIEW_SUCCESS,
    UPCOMING_RESERVATION_OVERVIEW_FAILURE,

    UPCOMING_RESERVATION_VOLUME_BY_SESSION_REQUEST,
    UPCOMING_RESERVATION_VOLUME_BY_SESSION_SUCCESS,
    UPCOMING_RESERVATION_VOLUME_BY_SESSION_FAILURE,

    UPCOMING_RESERVATION_VOLUME_REQUEST,
    UPCOMING_RESERVATION_VOLUME_SUCCESS,
    UPCOMING_RESERVATION_VOLUME_FAILURE,

    UPCOMING_RESERVATION_BY_SESSION_REQUEST,
    UPCOMING_RESERVATION_BY_SESSION_SUCCESS,
    UPCOMING_RESERVATION_BY_SESSION_FAILURE,

    UPCOMING_RESERVATION_STATUS_BY_DATE_REQUEST,
    UPCOMING_RESERVATION_STATUS_BY_DATE_SUCCESS,
    UPCOMING_RESERVATION_STATUS_BY_DATE_FAILURE,

    UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_REQUEST,
    UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_SUCCESS,
    UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_FAILURE,

    UPCOMING_RESERVATION_DETAILS_REQUEST,
    UPCOMING_RESERVATION_DETAILS_SUCCESS,
    UPCOMING_RESERVATION_DETAILS_FAILURE,

    RESERVATION_OVERVIEW_REQUEST,
    RESERVATION_OVERVIEW_SUCCESS,
    RESERVATION_OVERVIEW_FAILURE,

    RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_REQUEST,
    RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_SUCCESS,
    RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_FAILURE,

    RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_REQUEST,
    RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_SUCCESS,
    RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_FAILURE,

    RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_REQUEST,
    RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_SUCCESS,
    RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_FAILURE,

    RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_REQUEST,
    RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_SUCCESS,
    RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_FAILURE,

    RESERVATION_OVERVIEW_DETAILS_REQUEST,
    RESERVATION_OVERVIEW_DETAILS_SUCCESS,
    RESERVATION_OVERVIEW_DETAILS_FAILURE,

    RESERVATION_TREND_OVERVIEW_REQUEST,
    RESERVATION_TREND_OVERVIEW_SUCCESS,
    RESERVATION_TREND_OVERVIEW_FAILURE,

    RESERVATION_TREND_REQUEST,
    RESERVATION_TREND_SUCCESS,
    RESERVATION_TREND_FAILURE,

    RESERVATION_TREND_BY_GROUPS_REQUEST,
    RESERVATION_TREND_BY_GROUPS_SUCCESS,
    RESERVATION_TREND_BY_GROUPS_FAILURE,

    RESERVATION_TREND_BY_AVG_WAIT_TIME_REQUEST,
    RESERVATION_TREND_BY_AVG_WAIT_TIME_SUCCESS,
    RESERVATION_TREND_BY_AVG_WAIT_TIME_FAILURE,

    RESERVATION_TREND_CUSTOMER_TREND_REQUEST,
    RESERVATION_TREND_CUSTOMER_TREND_SUCCESS,
    RESERVATION_TREND_CUSTOMER_TREND_FAILURE,

    RESERVATION_TREND_CUSTOMER_VISITS_REQUEST,
    RESERVATION_TREND_CUSTOMER_VISITS_SUCCESS,
    RESERVATION_TREND_CUSTOMER_VISITS_FAILURE,

    UPCOMING_RESERVATION_START_DATE_CHANGE,
    UPCOMING_RESERVATION_END_DATE_CHANGE

} from "./reservationReportsConstants";


export const todaysReservationOverviewRequest = (data) => {
    return {
        type: TODAYS_RESERVATION_OVERVIEW_REQUEST,
        payload: data
    };
}

export const todaysReservationOverviewSuccess = (data) => {
    return {
        type: TODAYS_RESERVATION_OVERVIEW_SUCCESS,
        payload: data
    };
}

export const todaysReservationOverviewFailure = (error) => {
    return {
        type: TODAYS_RESERVATION_OVERVIEW_FAILURE,
        payload: error
    };
}

export const todaysReservationVolumeBySessionRequest = (data) => {
    return {
        type: TODAYS_RESERVATION_VOLUME_BY_SESSION_REQUEST,
        payload: data
    };
}

export const todaysReservationVolumeBySessionSuccess = (data) => {
    return {
        type: TODAYS_RESERVATION_VOLUME_BY_SESSION_SUCCESS,
        payload: data
    };
}

export const todaysReservationVolumeBySessionFailure = (error) => {
    return {
        type: TODAYS_RESERVATION_VOLUME_BY_SESSION_FAILURE,
        payload: error
    };
}

export const todaysAssignedReservationRequest = (data) => {
    return {
        type: TODAYS_ASSIGNED_RESERVATION_REQUEST,
        payload: data
    };
}

export const todaysAssignedReservationSuccess = (data) => {
    return {
        type: TODAYS_ASSIGNED_RESERVATION_SUCCESS,
        payload: data
    };
}

export const todaysAssignedReservationFailure = (error) => {
    return {
        type: TODAYS_ASSIGNED_RESERVATION_FAILURE,
        payload: error
    };
}

export const todaysUpcomingReservationRequest = (data) => {
    return {
        type: TODAYS_UPCOMING_RESERVATION_REQUEST,
        payload: data
    };
}

export const todaysUpcomingReservationSuccess = (data) => {
    return {
        type: TODAYS_UPCOMING_RESERVATION_SUCCESS,
        payload: data
    };
}

export const todaysUpcomingReservationFailure = (error) => {
    return {
        type: TODAYS_UPCOMING_RESERVATION_FAILURE,
        payload: error
    };
}

export const upcomingReservationOverviewRequest = (data) => {
    return {
        type: UPCOMING_RESERVATION_OVERVIEW_REQUEST,
        payload: data
    };
}

export const upcomingReservationOverviewSuccess = (data) => {
    return {
        type: UPCOMING_RESERVATION_OVERVIEW_SUCCESS,
        payload: data
    };
}

export const upcomingReservationOverviewFailure = (error) => {
    return {
        type: UPCOMING_RESERVATION_OVERVIEW_FAILURE,
        payload: error
    };
}

export const upcomingReservationVolumeBySessionRequest = (data) => {
    return {
        type: UPCOMING_RESERVATION_VOLUME_BY_SESSION_REQUEST,
        payload: data
    };
}

export const upcomingReservationVolumeBySessionSuccess = (data) => {
    return {
        type: UPCOMING_RESERVATION_VOLUME_BY_SESSION_SUCCESS,
        payload: data
    };
}

export const upcomingReservationVolumeBySessionFailure = (error) => {
    return {
        type: UPCOMING_RESERVATION_VOLUME_BY_SESSION_FAILURE,
        payload: error
    };
}

export const upcomingReservationVolumeRequest = (data) => {
    return {
        type: UPCOMING_RESERVATION_VOLUME_REQUEST,
        payload: data
    };
}

export const upcomingReservationVolumeSuccess = (data) => {
    return {
        type: UPCOMING_RESERVATION_VOLUME_SUCCESS,
        payload: data
    };
}

export const upcomingReservationVolumeFailure = (error) => {
    return {
        type: UPCOMING_RESERVATION_VOLUME_FAILURE,
        payload: error
    };
}

export const upcomingReservationBySessionRequest = (data) => {
    return {
        type: UPCOMING_RESERVATION_BY_SESSION_REQUEST,
        payload: data
    };
}

export const upcomingReservationBySessionSuccess = (data) => {
    return {
        type: UPCOMING_RESERVATION_BY_SESSION_SUCCESS,
        payload: data
    };
}

export const upcomingReservationBySessionFailure = (error) => {
    return {
        type: UPCOMING_RESERVATION_BY_SESSION_FAILURE,
        payload: error
    };
}

export const upcomingReservationStatusByDateRequest = (data) => {
    return {
        type: UPCOMING_RESERVATION_STATUS_BY_DATE_REQUEST,
        payload: data
    };
}

export const upcomingReservationStatusByDateSuccess = (data) => {
    return {
        type: UPCOMING_RESERVATION_STATUS_BY_DATE_SUCCESS,
        payload: data
    };
}

export const upcomingReservationStatusByDateFailure = (error) => {
    return {
        type: UPCOMING_RESERVATION_STATUS_BY_DATE_FAILURE,
        payload: error
    };
}

export const upcomingReservationCancellationByReasonsRequest = (data) => {
    return {
        type: UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_REQUEST,
        payload: data
    };
}

export const upcomingReservationCancellationByReasonsSuccess = (data) => {
    return {
        type: UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_SUCCESS,
        payload: data
    };
}

export const upcomingReservationCancellationByReasonsFailure = (error) => {
    return {
        type: UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_FAILURE,
        payload: error
    };
}

export const upcomingReservationDetailsRequest = (data) => {
    return {
        type: UPCOMING_RESERVATION_DETAILS_REQUEST,
        payload: data
    };
}

export const upcomingReservationDetailsSuccess = (data) => {
    return {
        type: UPCOMING_RESERVATION_DETAILS_SUCCESS,
        payload: data
    };
}

export const upcomingReservationDetailsFailure = (error) => {
    return {
        type: UPCOMING_RESERVATION_DETAILS_FAILURE,
        payload: error
    };
}
export const reservationOverviewRequest = (data) => {
    return {
        type: RESERVATION_OVERVIEW_REQUEST,
        payload: data
    };
}

export const reservationOverviewSuccess = (data) => {
    return {
        type: RESERVATION_OVERVIEW_SUCCESS,
        payload: data
    };
}

export const reservationOverviewFailure = (error) => {
    return {
        type: RESERVATION_OVERVIEW_FAILURE,
        payload: error
    };
}

export const reservationOverviewSlotWiseReservationRequest = (data) => {
    return {
        type: RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_REQUEST,
        payload: data
    };
}

export const reservationOverviewSlotWiseReservationSuccess = (data) => {
    return {
        type: RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_SUCCESS,
        payload: data
    };
}

export const reservationOverviewSlotWiseReservationFailure = (error) => {
    return {
        type: RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_FAILURE,
        payload: error
    };
}

export const reservationOverviewDailyReservationsGuestsRequest = (data) => {
    return {
        type: RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_REQUEST,
        payload: data
    };
}

export const reservationOverviewDailyReservationsGuestsSuccess = (data) => {
    return {
        type: RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_SUCCESS,
        payload: data
    };
}

export const reservationOverviewDailyReservationsGuestsFailure = (error) => {
    return {
        type: RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_FAILURE,
        payload: error
    };
}

export const reservationOverviewDineInDurationByGroupsRequest = (data) => {
    return {
        type: RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_REQUEST,
        payload: data
    };
}

export const reservationOverviewDineInDurationByGroupsSuccess = (data) => {
    return {
        type: RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_SUCCESS,
        payload: data
    };
}

export const reservationOverviewDineInDurationByGroupsFailure = (error) => {
    return {
        type: RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_FAILURE,
        payload: error
    };
}

export const reservationOverviewGuestSizeDistributionRequest = (data) => {
    return {
        type: RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_REQUEST,
        payload: data
    };
}

export const reservationOverviewGuestSizeDistributionSuccess = (data) => {
    return {
        type: RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_SUCCESS,
        payload: data
    };
}

export const reservationOverviewGuestSizeDistributionFailure = (error) => {
    return {
        type: RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_FAILURE,
        payload: error
    };
}

export const reservationOverviewDetailsRequest = (data) => {
    return {
        type: RESERVATION_OVERVIEW_DETAILS_REQUEST,
        payload: data
    };
}

export const reservationOverviewDetailsSuccess = (data) => {
    return {
        type: RESERVATION_OVERVIEW_DETAILS_SUCCESS,
        payload: data
    };
}

export const reservationOverviewDetailsFailure = (error) => {
    return {
        type: RESERVATION_OVERVIEW_DETAILS_FAILURE,
        payload: error
    };
}

export const reservationTrendOverviewRequest = (data) => {
    return {
        type: RESERVATION_TREND_OVERVIEW_REQUEST,
        payload: data
    };
}

export const reservationTrendOverviewSuccess = (data) => {
    return {
        type: RESERVATION_TREND_OVERVIEW_SUCCESS,
        payload: data
    };
}

export const reservationTrendOverviewFailure = (error) => {
    return {
        type: RESERVATION_TREND_OVERVIEW_FAILURE,
        payload: error
    };
}

export const reservationTrendRequest = (data) => {
    return {
        type: RESERVATION_TREND_REQUEST,
        payload: data
    };
}

export const reservationTrendSuccess = (data) => {
    return {
        type: RESERVATION_TREND_SUCCESS,
        payload: data
    };
}

export const reservationTrendFailure = (error) => {
    return {
        type: RESERVATION_TREND_FAILURE,
        payload: error
    };
}

export const reservationTrendByGroupsRequest = (data) => {
    return {
        type: RESERVATION_TREND_BY_GROUPS_REQUEST,
        payload: data
    };
}

export const reservationTrendByGroupsSuccess = (data) => {
    return {
        type: RESERVATION_TREND_BY_GROUPS_SUCCESS,
        payload: data
    };
}

export const reservationTrendByGroupsFailure = (error) => {
    return {
        type: RESERVATION_TREND_BY_GROUPS_FAILURE,
        payload: error
    };
}

export const reservationTrendByAvgWaitTimeRequest = (data) => {
    return {
        type: RESERVATION_TREND_BY_AVG_WAIT_TIME_REQUEST,
        payload: data
    };
}

export const reservationTrendByAvgWaitTimeSuccess = (data) => {
    return {
        type: RESERVATION_TREND_BY_AVG_WAIT_TIME_SUCCESS,
        payload: data
    };
}

export const reservationTrendByAvgWaitTimeFailure = (error) => {
    return {
        type: RESERVATION_TREND_BY_AVG_WAIT_TIME_FAILURE,
        payload: error
    };
}

export const reservationTrendCustomerTrendRequest = (data) => {
    return {
        type: RESERVATION_TREND_CUSTOMER_TREND_REQUEST,
        payload: data
    };
}

export const reservationTrendCustomerTrendSuccess = (data) => {
    return {
        type: RESERVATION_TREND_CUSTOMER_TREND_SUCCESS,
        payload: data
    };
}

export const reservationTrendCustomerTrendFailure = (error) => {
    return {
        type: RESERVATION_TREND_CUSTOMER_TREND_FAILURE,
        payload: error
    };
}

export const reservationTrendCustomerVisitsRequest = (data) => {
    return {
        type: RESERVATION_TREND_CUSTOMER_VISITS_REQUEST,
        payload: data
    };
}

export const reservationTrendCustomerVisitsSuccess = (data) => {
    return {
        type: RESERVATION_TREND_CUSTOMER_VISITS_SUCCESS,
        payload: data
    };
}

export const reservationTrendCustomerVisitsFailure = (error) => {
    return {
        type: RESERVATION_TREND_CUSTOMER_VISITS_FAILURE,
        payload: error
    };
}

export const upcomingReservationChangeStartDate = (data) => {
    return {
        type: UPCOMING_RESERVATION_START_DATE_CHANGE,
        payload: data
    };
};

export const upcomingReservationChangeEndDate = (data) => {
    return {
        type: UPCOMING_RESERVATION_END_DATE_CHANGE,
        payload: data
    };
};

